import masonry from "masonry-layout";

function masonryGallery() {
    const elem = document.querySelector('.freecontent__gallery');
    const masonry = new Masonry( elem, {
        itemSelector: '.freecontent__gallery-item',
        gutter: 20,
        originTop: true,
    });
}

document.onreadystatechange = () => {
    masonryGallery();
} 